import React from "react";
import { Link } from "react-router-dom";

import { FAKE_PROVIDERS } from '../../../constants';
import { LoadingSpinner } from "../partials/LoadingSpinner";
import "./SelectProvider.css";

export const SelectProvider = (props) => {
  const listProviders = () => {
    return FAKE_PROVIDERS.map((item) => {
      return (
        <div
          className={
            "SelectProvider__provider-row__item border-dark " + item.type + (!item.enabled && " disabled")
          }
          key={item.type}
        >
          <div className={`logo img_${item.type}`}></div>
          <div className="content-wrapper">
            {item.enabled ? (
              <Link to={'/user/provider/' + item.link} className="global-success-button">
                Start integration
              </Link>
            ) : (
              <p>Coming soon</p>
            )}
          </div>
        </div>
      );
    });
  };

  const headingContent = () => {
    if (props.location.state === undefined) {
      return <h2 className='default-title'>Integrations</h2>;
    } else {
      if (props.location.state.hasOwnProperty("fromRegistration")) {
        return (
          <h3 className="SelectProvider__page-title">
            Your account sucessfully created, one step left to become
            {/*eslint-disable-next-line*/}
            <a href="#"> VAT compiliant</a>
          </h3>
        );
      } else {
        return;
      }
    }
  };

  return (
    <div className="SelectProvider">
      <div className="registration-page-step">
        {headingContent()}

        <div className="SelectProvider__provider-row">
          {FAKE_PROVIDERS.length > 0 ? (
            listProviders()
          ) : (
            <LoadingSpinner/>
          )}
        </div>
      </div>
    </div>
  );
};
